import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './tipping.json';

const Tipping = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Tipping culture, service industry, and etiquette vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Tipping"
            image="/Images/tipping.webp"
            seoTitle="Free English Lesson Plans: Tipping"
            seoDescription="Tipping culture, service industry, and etiquette vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Tipping;


